
import { Component, Prop, Vue } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { TransactionCard } from '../TransactionCard';
import {
  ContextColorProvider,
  NavBar,
  IconButton,
  RoundedIcon,
  Heading
} from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    ContextColorProvider,
    TransactionCard,
    IconButton,
    NavBar,
    RoundedIcon,
    Heading
  }
})
export default class InvestmentSuccess extends Vue {
  @Prop({ type: String, default: 'Investimento realizado.' })
  private title!: string;

  @Prop({ type: String, required: true })
  private backButtonAriaLabel!: string;

  private handleBackClick() {
    this.$emit('on-back');
  }

  private get NebraskaColors() {
    return NebraskaColors;
  }
}
